import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  input: {
    margin: "0 !important",
  },
}));
